import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createEventChainLink } from '../index';
export const useCreateEventChainLink = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createEventChainLink, {
        onSuccess: () => {
            queryClient.invalidateQueries('EventChainLinks');
            setAction({
                type: 'success',
                message: 'Creating the event chain link was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
